import { Drawer, Grid, Typography } from '@mui/material';
import { useMemo } from 'react';
import { AllIcxInfo } from '../IndustryLandList';
import {
  RndTable,
  BasicTable,
  EmployeesTable,
  KeyResultTable,
  InformationTable,
  ActivitiesProductTable,
  ExportPerformanceTable,
  ProductionPerformanceTable,
  GetLavelue
} from './Tables';

interface IndustryLandDetailDrawerProps {
  open: boolean;
  onClose: () => void;
  detailInfo?: AllIcxInfo;
}

const IndustryLandDetailDrawer = ({
  open,
  onClose,
  detailInfo
}: IndustryLandDetailDrawerProps) => {
  if (!detailInfo) {
    return null;
  }
  const getEntryProps = (key: string, value: string | GetLavelue) => {
    if (typeof value === 'string') {
      return { label: value, value: detailInfo[key as keyof AllIcxInfo] };
    }
    return value(detailInfo);
  };

  const InformationSection = useMemo(
    () =>
      ({
        title,
        table
      }: {
        title: string;
        table: {
          [p: string]: string | GetLavelue;
        };
      }) => {
        return (
          <Grid container padding={2} bgcolor={'#F8F8F8'}>
            <Grid container gap={2}>
              <Grid item xs={12} container gap={1}>
                <Typography variant="h6">{title}</Typography>
                {Object.entries(table).map(([key, value]) => {
                  const t = getEntryProps(key, value);
                  return <Entry key={key} label={t.label} value={t.value} />;
                })}
              </Grid>
            </Grid>
          </Grid>
        );
      },
    [detailInfo]
  );

  return (
    <Drawer anchor={'right'} open={open} onClose={onClose}>
      <Grid container width={'70vh'} padding={2} gap={3}>
        <InformationSection title={'기본 정보'} table={BasicTable} />
        <InformationSection title={'주요 결과'} table={KeyResultTable} />
        <InformationSection
          title={'기업체 활동'}
          table={ActivitiesProductTable}
        />
        <InformationSection title={'대표 정보'} table={InformationTable} />
        <InformationSection title={'연구 개발'} table={RndTable} />
        <InformationSection
          title={'생산 실적'}
          table={ProductionPerformanceTable}
        />
        <InformationSection
          title={'수출 실적'}
          table={ExportPerformanceTable}
        />
        <InformationSection title={'종사자'} table={EmployeesTable} />
      </Grid>
    </Drawer>
  );
};
export default IndustryLandDetailDrawer;

const Entry = ({ label, value }: { label: string; value?: string | null }) => (
  <Grid container>
    <Grid container item xs={4} justifyContent={'flex-start'}>
      {label}
    </Grid>
    <Grid container item xs={8} justifyContent={'flex-start'}>
      {renderText(label, value)}
    </Grid>
  </Grid>
);

const renderText = (label: string, value?: string | null) => {
  if (label === '회사 홈페이지') {
    return (
      <a target={'_blank'} href={`http://${value}`}>
        {value}
      </a>
    );
  }
  return !value?.length ? '-' : value;
};
